import React, { Component } from 'react';
import BasicTitle from '../../layout/titles/BasicTitle';

export default class EmailForm extends Component {
    constructor( props ) {
        super(props);
        this.state = {
            name: '',
            email: '',
            subject: '',
            message: '',
            toggle: false,
            disabled: '',
            animation: '',
            updater: '',
            success: 'Send'
        }
    }

    //handle the Submission
    handleSubmit( event ){
        event.preventDefault();

        const templateId = 'template_Sn1dp1xU';
        this.contact(templateId, {message_html: this.state.message, 
                                  from_name: this.state.name, 
                                  reply_to: this.state.email, 
                                  subject: this.state.subject
                                })
    }

    // Send the mail
    contact(templateId, variables){
       //disable button to prevent spam and begin sending
       this.toggleButton();
       this.sending();
       window.emailjs.send(
           'gmail', templateId,
           variables
       ).then(res => {
           //reset the form and indicate that it was sent
           this.resetForm();
           this.sent();
       }).catch(err => {
           console.error("Something went wrong");
           this.failed();
           //retry - reactivate button
           this.toggleButton()
           
        })
        this.resetForm();
    }


    //toggle the button
    toggleButton(){
        this.state.toggle ? 
            this.enableButton()
            : 
            this.disableButton()
    }

    //disable button
    disableButton(){
        this.setState({toggle: true});
        this.setState({disabled: "contact__btn--disabled"});
        console.log("disabled!");
    }

    //enable button
    enableButton(){
        this.setState({toggle: false});
        this.setState({disabled: ''});
        console.log("enabled!");
    }

    //indicators
    sending(){
        this.setState({updater: 'Sending...'});
    }
    sent(){
        this.setState({updater: 'Sent!'});
        this.setState({success: 'Disabled'});
    }
    failed(){
        this.setState({updater: 'Failed!'});
    }
    //indicators


    resetForm(){
        this.setState({name: '', email: '', subject: '', message: ''})
     }


    render() {
        return (
            <div className="contact__box">
            <div className="contact--title-box">
                <h3 className="contact--title">Contact</h3>
            </div>
            <form className="contact__form-box" 
                id="contact-form" 
                onSubmit={this.handleSubmit.bind(this)} 
                method="POST">

                    {/* Name */}
                    <div className="contact__form--input-box contact__form--input-box--1">
                        <input className="contact__form--input contact__form__details--input" 
                               placeholder="Name" 
                               type="text" 
                               required 
                               value={ this.state.name } 
                               onChange={ this.onNameChange.bind(this)}></input>
                        <label className="contact__form--label contact__form__details--label" htmlFor="name">Your name</label>
                    </div>

                    {/* Email */}
                    <div className="contact__form--input-box contact__form--input-box--2">
                        <input className="contact__form--input contact__form__details--input" 
                               placeholder="Email" 
                               type="email" 
                               required 
                               value={ this.state.email } 
                               onChange={ this.onEmailChange.bind(this) }></input>
                        <label className="contact__form--label contact__form__details--label" 
                               htmlFor="email">Your email</label>
                    </div>


                    {/* Subject */}
                    <div className="contact__form--input-box contact__form--input-box--3">
                        <input className="contact__form--input contact__form__details--input"
                               placeholder="Subject" 
                               type="text" 
                               required 
                               value={ this.state.subject } 
                               onChange={ this.onSubjectChange.bind(this) } >    
                        </input>
                        <label className="contact__form--label contact__form__details--label" 
                                htmlFor="subject">
                            Subject
                        </label>
                    </div>

                    {/* Content */}
                    <div className="contact__form--input-box contact__form--input-box--4">
                        <textarea className="contact__form--input contact__form__message--input" placeholder="Message" type="text" required value={ this.state.message } onChange={ this.onMessageChange.bind(this) } rows="5" ></textarea>
                        <label className="contact__form--label contact__form__message--label" htmlFor="message">Your message</label>
                    </div>

                    {/* Submit */}
                    <div className="contact__btn-box">
                        <button onClick={this.startStopAnimation} disabled={this.state.toggle} className={`contact__btn ${this.state.disabled}`} type="submit">{this.state.success}</button>
                        <p className="contact__btn--updater">{this.state.updater}</p>
                    </div>
            </form>
            </div>

            
        )
    }

    //track the form input and change the state
    onNameChange(event) {
        this.setState({name: event.target.value})
      }
    
    onEmailChange(event) {
        this.setState({email: event.target.value})
    }

    onSubjectChange(event) {
        this.setState({subject: event.target.value})
    }

    onMessageChange(event) {
        this.setState({message: event.target.value})
    }
}